export default {
  block: {
    marginBottom: 32,
  },

  section: {
    marginBottom: 30,
  },
};
